export const basedDomin = "https://admin.cars-ser.com/api";
export const apiHeaders = {
    headers: {
      Accept: "application/json",
    },
  };
